import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {enumPolicies} from '../../_metronic/helpers'
import PolicyChecker from '../../_metronic/helpers/components/PolicyChecker'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import UserPage from '../pages/user-management/UserPage'
import UserEditPage from '../pages/user-management/user'
import CustomersPage from '../pages/customer-management/customers'
import CustomerPage from '../pages/customer-management/customer'
import ProfilePage from '../pages/profile/profile'
import ProductsPage from '../pages/catalog-management/product/products'
import ProductPage from '../pages/catalog-management/product/product'
import CategoryPage from '../pages/catalog-management/category/CategoryPage'
import SuppliersPage from '../pages/user-management/supplier/suppliers'
import SupplierPage from '../pages/user-management/supplier/supplier'
import StocksPage from '../pages/stock-management/stock/stocks'
import StockPage from '../pages/stock-management/stock/stock'
import StockOperation from '../pages/stock-management/stock/stock-operation'
import DevSupportTicketsPage from '../pages/dev-support/devSupportTickets'
import DevSupportTicketPage from '../pages/dev-support/devSupportTicket'
import PrintPage from '../pages/stock-management/stock/print'
import PricePage from '../pages/price-management/PricePage'
import VerandaCalculator from '../pages/veranda-calculator/verandaCalculator'
import Checkout from '../pages/checkout/checkout'
import CheckoutSummary from '../pages/checkout/checkout-summary'
import CheckoutThanks from '../pages/checkout/checkout-thanks'
import Orders from '../pages/order/orders'
import Order from '../pages/order/order'
import Pay from '../pages/checkout/pay'
import Contents from '../pages/localization/contents'
import Resources from '../pages/localization/resources'
import Leads from '../pages/lead-management/leads'
import Invoices from '../pages/invoice/invoices'
import Invoice from '../pages/invoice/invoice'
import Quotes from '../pages/quote/quotes'
import Quote from '../pages/quote/quote'
import CompanySetting from '../pages/setting/companySetting'
import InvoiceSetting from "../pages/setting/invoiceSetting";
import QuotationSetting from "../pages/setting/quotationSetting";
import EmailSettings from '../pages/setting/emailSettings'
import NotificationTemplateSettings from '../pages/setting/notificationTemplateSettings'
import Discounts from '../pages/discount-management/discounts'
import Discount from '../pages/discount-management/discount'
import Productions from '../pages/production/productions'

const PrivateRoutes = () => {

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />

        {/* Lazy Modules */}

        <Route
          path='user-management'
          element={
            <PolicyChecker
              policies={[
                enumPolicies.UserWrite,
                enumPolicies.UserEdit,
                enumPolicies.UserDealerRead,
                enumPolicies.CustomerRead,
                enumPolicies.CustomerEdit,
                enumPolicies.CustomerWrite,
                enumPolicies.ProductRead,
                enumPolicies.ProductEdit,
                enumPolicies.ProductWrite,
                enumPolicies.ProductPriceRead,
              ]}
            >
              <UserPage />
            </PolicyChecker>
          }
        />
        <Route path='user-management/users/:id' element={<UserEditPage />} />
        <Route path='customer-management/customers' element={<CustomersPage />} />
        <Route path='customer-management/customers/:id' element={<CustomerPage />} />

        <Route path='catalog-management/products' element={<ProductsPage />} />
        <Route path='catalog-management/products/:id' element={<ProductPage />} />
        <Route path='catalog-management/products/:id/detail' element={<ProductPage />} />
        <Route path='catalog-management/categories' element={<CategoryPage />} />

        <Route path='user-management/suppliers' element={<SuppliersPage />} />
        <Route path='user-management/suppliers/:id' element={<SupplierPage />} />

        <Route path='stock-management/stocks' element={<StocksPage />} />
        <Route path='stock-management/stocks/:id' element={<StockPage />} />

        <Route path='price-management' element={<PricePage />} />
        <Route path='veranda-calculator' element={<VerandaCalculator />} />

        <Route path='checkout-management/checkout' element={<Checkout />} />
        <Route path='checkout-management/checkout-summary' element={<CheckoutSummary />} />
        <Route path='checkout-management/pay' element={<Pay />} />
        <Route path='checkout-management/checkout-thanks/:id' element={<CheckoutThanks />} />

        <Route path='order-management/orders' element={<Orders />} />
        <Route path='order-management/orders/:id' element={<Order />} />

        <Route path='order-management/invoices' element={<Invoices />} />
        <Route path='order-management/invoices/:id' element={<Invoice />} />

        <Route path='order-management/quotes' element={<Quotes />} />
        <Route path='order-management/quotes/:id' element={<Quote />} />

        <Route path='order-management/discounts' element={<Discounts />} />
        <Route path='order-management/discounts/:id' element={<Discount />} />

        <Route path='production-management/productions' element={<Productions />} />

        <Route path="stock-management/stocks-operation" element={<StockOperation />}>
          <Route path=":id" element={<StockOperation />} />
        </Route>

        <Route path="stock-management/stocks-print" element={<PrintPage />}>
          <Route path=":id" element={<PrintPage />} />
        </Route>

        <Route path='profile' element={<ProfilePage />} />

        {/* Help */}
        <Route path='dev-support/tickets' element={<DevSupportTicketsPage />} />
        <Route path='dev-support/tickets/:id' element={<DevSupportTicketPage />} />

        <Route path='localization/contents' element={<Contents />} />
        <Route path='localization/resources' element={<Resources />} />

        <Route path='lead-management/leads' element={<Leads />} />

        <Route path='setting-management/company' element={<CompanySetting />} />
        <Route path='setting-management/invoice' element={<InvoiceSetting />} />
        <Route path='setting-management/quotation' element={<QuotationSetting />} />
        <Route path='setting-management/email' element={<EmailSettings />} />
        <Route path='setting-management/notification-template' element={<NotificationTemplateSettings />} />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

export { PrivateRoutes }
